import { render } from "./V1StyleBottom.vue?vue&type=template&id=6e8770ba&scoped=true"
import script from "./V1StyleBottom.vue?vue&type=script&lang=js"
export * from "./V1StyleBottom.vue?vue&type=script&lang=js"

import "./V1StyleBottom.vue?vue&type=style&index=0&id=6e8770ba&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e8770ba"]])

export default __exports__